export default "__VITE_ASSET__7f7c1e20__"